import React from 'react';
import { VStack, HStack, Heading, Text, Badge, SimpleGrid, Box, Divider, Spacer, Button, Flex } from '@chakra-ui/react';
import { MdSearch, MdVisibility } from 'react-icons/md';
import { VirtualizedGridConfig, FilterField } from '../../components/VirtualizedGrid';

// Configuración del grid para predios
export const prediosGridConfig: VirtualizedGridConfig = {
  itemsPerRow: 4,
  itemHeight: 350,
  containerHeight: 1750, // 20 items = 5 filas * 350px altura
  searchFields: [
    'ClaveCatastral.claveCatastralEstandar',
    'ClaveCatastral.PropietarioPredio.0.Propietario.nombre',
    'ClaveCatastral.PropietarioPredio.0.Propietario.primerApellido',
    'ClaveCatastral.PropietarioPredio.0.Propietario.segundoApellido',
    'ClaveCatastral.cLocalidad.descripcion',
    'paraje'
  ]
};

// Campos de filtro para predios
export const prediosFilterFields: FilterField[] = [
  {
    key: 'texto',
    type: 'text',
    placeholder: 'Buscar por clave, propietario o localidad',
    icon: <MdSearch color="gray.300" />
  },
  {
    key: 'ClaveCatastral.cLocalidad.descripcion',
    type: 'text',
    placeholder: 'Filtrar por Localidad'
  },
  {
    key: 'paraje',
    type: 'text',
    placeholder: 'Filtrar por Paraje'
  },
  {
    key: 'ClaveCatastral.cTipoPredio.descripcion',
    type: 'select',
    placeholder: 'Tipo de Predio',
    options: [
      { value: 'URBANO', label: 'Urbano' },
      { value: 'RUSTICO', label: 'Rústico' },
      { value: 'SUBURBANO', label: 'Suburbano' },
      { value: 'SIN USO', label: 'Sin Uso' }
    ]
  }
];

// Función para obtener el tipo de predio por ID
const getTipoPredioPorId = (idTipoPredio: string) => {
  const tipos: { [key: string]: string } = {
    'D': 'SIN USO',
    'R': 'RÚSTICO',
    'S': 'SUBURBANO',
    'U': 'URBANO'
  };
  return tipos[idTipoPredio] || 'N/A';
};

// Función render para las tarjetas de predios
export const renderPredioCard = (predio: any, index: number, onRowClick: (id: string) => void) => {
  return (
    <VStack align="stretch" spacing={3}>
      {/* Header */}
      <Flex align="center">
        <VStack align="start" spacing={0}>
          <Heading size="md" color="#5b182b">
            {predio.ClaveCatastral?.claveCatastralEstandar || "Sin clave"}
          </Heading>
          <Text fontSize="sm" color="gray.500">
            Predio
          </Text>
        </VStack>
        <Spacer />
      </Flex>

      <Divider />

      {/* Información Principal */}
      <VStack align="stretch" spacing={2}>
        <Box>
          <Text fontWeight="semibold" fontSize="sm" color="gray.700">
            Propietario
          </Text>
          <Text fontSize="sm" noOfLines={2}>
            {`${
              predio.ClaveCatastral?.PropietarioPredio?.[0]
                ?.Propietario?.nombre || "N/A"
            } ${
              predio.ClaveCatastral?.PropietarioPredio?.[0]
                ?.Propietario?.primerApellido || ""
            } ${
              predio.ClaveCatastral?.PropietarioPredio?.[0]
                ?.Propietario?.segundoApellido || ""
            }`.trim()}
          </Text>
        </Box>
        
        <SimpleGrid columns={2} spacing={3}>
          <Box>
            <Text fontWeight="semibold" fontSize="sm" color="gray.700">
              Localidad
            </Text>
            <Text fontSize="sm">
              {predio.ClaveCatastral?.cLocalidad?.descripcion || "N/A"}
            </Text>
          </Box>
          <Box>
            <Text fontWeight="semibold" fontSize="sm" color="gray.700">
              Tipo
            </Text>
            <Badge 
              bg={predio.ClaveCatastral?.idTipoPredio === 'U' ? '#5b182b' : '#bb8c52'}
              color="white"
              variant="solid"
              borderRadius="full"
            >
              {getTipoPredioPorId(predio.ClaveCatastral?.idTipoPredio)}
            </Badge>
          </Box>
        </SimpleGrid>

        <Box>
          <Text fontWeight="semibold" fontSize="sm" color="gray.700">
            Paraje o Denominación
          </Text>
          <Text fontSize="sm" noOfLines={2}>
            {predio.paraje || "Sin especificar"}
          </Text>
        </Box>
      </VStack>

      <Divider />

      {/* Acciones */}
      <HStack spacing={2} justify="center">
        <Button
          size="sm"
          bg="#5b182b"
          color="white"
          _hover={{ bg: "#691f30" }}
          onClick={(e) => {
            e.stopPropagation();
            onRowClick(predio.id);
          }}
          leftIcon={<MdVisibility />}
        >
          Ver Detalles
        </Button>
      </HStack>
    </VStack>
  );
};